/* oxlint-disable typescript/no-explicit-any */
import type { FetchResponse } from '@cian/http-api';
import { fetchValidateAddressWeb } from '../../../common/repositories/price-estimator/v1/validate-address-web';
import type { TValidateAddressWebResponse } from '../../../common/repositories/price-estimator/v1/validate-address-web/types';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { IThunkApi } from '../../types/redux';
import { ECurrentErrorField } from 'shared/mf-my-home/types/formFields';

import { selectFormFields } from '../../selectors';
import { setError, setFormValid } from '../../slices';

/**
 * Валидатор фильтров для типа оцениваемой недвижимости "Квартиры"
 * Проверяет наличие обязательных полей, соответствие их условиям
 * Отправляет запрос к АПИ, валидируя адрес
 * */
export const validateFlatFormFields = createAsyncThunk<void, undefined, IThunkApi>(
  'validateFlatFormFields',
  async (_, _thunkApi) => {
    const {
      dispatch,
      getState,
      extra: { logger, httpApi },
    } = _thunkApi;
    const state = getState();

    const { address, area, roomsCount, flatNumber } = selectFormFields(state);

    if (!address) {
      dispatch(
        setError({
          currentErrorField: ECurrentErrorField.address,
          errorText: 'Укажите адрес',
        }),
      );

      dispatch(setFormValid(false));

      return;
    }

    if (!flatNumber) {
      dispatch(
        setError({
          currentErrorField: ECurrentErrorField.flatNumber,
          errorText: 'Укажите квартиру',
        }),
      );

      dispatch(setFormValid(false));

      return;
    }

    if (!roomsCount) {
      dispatch(
        setError({
          currentErrorField: ECurrentErrorField.roomsCount,
          errorText: 'Укажите кол-во комнат',
        }),
      );

      dispatch(setFormValid(false));

      return;
    }

    if (!area) {
      dispatch(
        setError({
          currentErrorField: ECurrentErrorField.area,
          errorText: 'Укажите площадь',
        }),
      );

      dispatch(setFormValid(false));

      return;
    }

    if (area > 1000) {
      dispatch(
        setError({
          currentErrorField: ECurrentErrorField.area,
          errorText: 'Недопустимое значение',
        }),
      );

      dispatch(setFormValid(false));

      return;
    }

    try {
      const response = (await fetchValidateAddressWeb({
        httpApi,
        parameters: { address },
      })) as FetchResponse<TValidateAddressWebResponse>;

      if (response.statusCode === 400) {
        const errors = response.response.errors || [];
        const error: any = errors[0] || {};
        const { key, message } = error;

        if (key && message) {
          dispatch(
            setError({
              currentErrorField: key,
              errorText: message,
            }),
          );
        }

        dispatch(setFormValid(false));

        return;
      }

      if (response.response.houseId) {
        dispatch(setFormValid(true));
      }
    } catch (e) {
      logger.error('Unable to validate flat address', e);

      dispatch(setFormValid(false));

      return;
    }

    dispatch(setFormValid(true));

    return;
  },
);
